import React from "react";
import useIntersectionObserver from "../hooks/useIntersectionObserver";
import Hero from "../components/Hero";
import HomeAbout from "../components/HomeAbout";
import Event from "../components/Event";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";

function Home() {
	const sectionsRef = useIntersectionObserver(
		(target) => target.classList.add("visible"),
		{ threshold: 0.1 },
	);

	return (
		<section className="homeContainer">
			<div ref={(el) => (sectionsRef.current[0] = el)} className="animate">
				<Hero />
			</div>
			<div ref={(el) => (sectionsRef.current[1] = el)} className="animate">
				<HomeAbout />
			</div>
			<div ref={(el) => (sectionsRef.current[2] = el)} className="animate">
				<Event />
			</div>
			<div ref={(el) => (sectionsRef.current[3] = el)} className="animate">
				<FAQ />
			</div>
			<div ref={(el) => (sectionsRef.current[4] = el)} className="animate">
				<Contact />
			</div>
		</section>
	);
}

export default Home;
